<div class="progress-wrapper" *ngIf="(profile$ | async)?.name">
    <ridango-page-content-wrapper>
        <ridango-progress-v2 [steps]="steps" [activeStep]="activeStep$ | async"></ridango-progress-v2>
    </ridango-page-content-wrapper>
</div>

<div class="block" id="main-content" *ngIf="(profile$ | async)?.name">
    <div class="block--wrap block"></div>
    <router-outlet></router-outlet>
</div>

<div class="block--content block" id="main-content" *ngIf="!(profile$ | async)?.name">
    <div class="block--wrap block">
        <rwidget-empty-state
            [title]="'PROFILE_NAME_EMPTY_STATE_TITLE'"
            [description]="'PROFILE_NAME_EMPTY_STATE_DESCRIPTION'">
            <ion-button
                class="flex-center width-220 btn btn--primary dark:text-contrast-black"
                [attr.aria-label]="'BTN_EDIT_PROFILE' | translate"
                (click)="redirectToProfile()"
                fill="clear">
                <ion-label class="text-base normal-case">
                    {{ 'BTN_EDIT_PROFILE' | translate }}
                </ion-label>
            </ion-button>
        </rwidget-empty-state>
    </div>
</div>
